import Cookies from "js-cookie";

(function consentBanner() {
    const CONSENT_COOKIE_DAYS = 180;

    const defaultConsentTypes = {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied"
    };

    window.dataLayer = window.dataLayer || [];

    function gtag() {
        window.dataLayer.push(arguments);
    }

    function normalizeConsentTypes(types = {}) {
        return Object.keys(defaultConsentTypes).reduce((acc, key) => {
            acc[key] = types[key] === "granted" ? "granted" : "denied";
            return acc;
        }, {});
    }

    function sendConsent(command, types) {
        gtag("consent", command, normalizeConsentTypes(types));

        window.dataLayer.push({
            event: "consent_state_update",
            consent_status: normalizeConsentTypes(types)
        });
    }

    let consent = {
        modal: "[data-component='consent-modal']",
        fadeTransition: 300,
        cookie: "consent-cookie",
        accepted: false,

        types: { ...defaultConsentTypes },

        consentListeners: [],

        actions: {
            accept: "accept",
            show: "show",
            close: "close",
            grantAll: "grantAll",
            denyAll: "denyAll"
        },

        data: {
            action: "data-consent",
            currentView: "data-current-view",
            view: "data-consent-view",
            types: "data-consent-types"
        },

        show: function (view = 1) {
            let modal = document.querySelector(this.modal);
            let currentView = document.querySelector(`[${this.data.currentView}]`);

            if (!modal || !currentView) {
                return;
            }

            currentView.setAttribute(this.data.currentView, view);

            if (modal.style.display === "none" || !modal.style.display) {
                modal.style.display = "block";
                setTimeout(() => {
                    modal.style.opacity = "1";
                }, 10);
                modal.style.transition = `opacity ${this.fadeTransition}ms`;
            }
        },

        close: function () {
            let modal = document.querySelector(this.modal);

            if (!modal) {
                return;
            }

            modal.style.opacity = "0";
            setTimeout(() => {
                modal.style.display = "none";
            }, this.fadeTransition);
        },

        setAll: function (status) {
            this.accepted = true;

            for (let type in this.types) {
                this.types[type] = status;
            }
        },

        updateCookie: function (accepted = this.accepted, types = this.types) {
            let cookie = {
                accepted,
                types: normalizeConsentTypes(types)
            };

            Cookies.set(this.cookie, JSON.stringify(cookie), {
                secure: true,
                sameSite: "Lax",
                expires: CONSENT_COOKIE_DAYS
            });

            sendConsent("update", cookie.types);

            this.consentListeners.forEach(function (callback) {
                callback(cookie.types);
            });
        },

        registerEventListeners: function () {
            document.querySelectorAll(`[${consent.data.action}="${consent.actions.denyAll}"]`).forEach(function (element) {
                element.addEventListener("click", function () {
                    consent.setAll("denied");
                    consent.updateCookie();
                    consent.close();
                });
            });

            document.querySelectorAll(`[${consent.data.action}="${consent.actions.grantAll}"]`).forEach(function (element) {
                element.addEventListener("click", function () {
                    consent.setAll("granted");
                    consent.updateCookie(true);
                    consent.close();
                });
            });

            document.querySelectorAll(`[${consent.data.action}="${consent.actions.close}"]`).forEach(function (element) {
                element.addEventListener("click", function () {
                    consent.close();
                });
            });
        },

        init: function () {
            let cookie = Cookies.get(this.cookie);

            if (cookie) {
                try {
                    cookie = JSON.parse(cookie);
                    this.accepted = Boolean(cookie.accepted);
                    this.types = normalizeConsentTypes(cookie.types);
                } catch (error) {
                    this.accepted = false;
                    this.types = { ...defaultConsentTypes };
                }
            } else {
                this.accepted = false;
                this.types = { ...defaultConsentTypes };
            }

            // This is the missing piece:
            // Send default consent on load using cookie values, or denied if no valid cookie exists.
            sendConsent("default", this.types);

            window.addConsentListener = (callback) => {
                this.consentListeners.push(callback);
            };

            if (!document.querySelector(this.modal)) {
                return;
            }

            this.registerEventListeners();

            if (!this.accepted) {
                this.show();
            }
        }
    };

    consent.init();
})();